import { Typography } from "@mui/material";

interface PageHeadingProps {
    firstHeading?: string;
    lastHeading: string;
}

function PageHeading(props: PageHeadingProps) {
    return (
        <Typography
            sx={{
                mb: "6px",
                fontSize: "16px",
                fontWeight: "400",
                fontFamily:'Poppins',
                color: "#ffffff",
                borderBottom: "1px solid #414141",
            }}
        ><span style={{color:'#FBBE07'}}>{props.firstHeading}</span>{" "}{props.lastHeading}
        </Typography>
    );
}

export default PageHeading;
